const FREIGHT_DETAILS = {
  header: {
    textContent: "Freight Details"
  },
  rows: [
    { textContent: "Origin" },
    { textContent: "Destination" },
    { textContent: "Number of Pieces" },
    { textContent: "Total Weight (lb.)" },
    { textContent: "Dimensions (inches)" },
    { textContent: "Commodity" }
  ]
};

const FREIGHT_DETAILS_SPANISH = {
  header: {
    textContent: "Detalles de la Carga"
  },
  rows: [
    { textContent: "Origen" },
    { textContent: "Destino" },
    { textContent: "Número de piezas" },
    { textContent: "Peso total (lb.)" },
    { textContent: "Dimensiones (inches)" },
    { textContent: "Tipo de carga" }
  ]
};

const FREIGHT_DETAILS_TEMPCONTROL = {
  header: {
    textContent: "Freight Details"
  },
  rows: [
    { textContent: "Origin Zip Code" },
    { textContent: "Destination Zip Code" },
    { textContent: "Number of Pieces" },
    { textContent: "Total Weight (lb.)" },
    { textContent: "Dimensions (inches)" },
    { textContent: "Commodity" }
  ]
};

const FREIGHT_DETAILS_TEMPCONTROL_SPANISH = {
  header: {
    textContent: "Detalles de la Carga"
  },
  rows: [
    { textContent: "Origen" },
    { textContent: "Destino" },
    { textContent: "Número de piezas" },
    { textContent: "Peso Total (lb.)" },
    { textContent: "Dimensiones (inches)" },
    { textContent: "Commodity" }
  ]
};

const QUOTE_INFORMATION = {
  header: {
    textContent: "Quote Information"
  },
  rows: [
    [{ Mode: "" }, { Equipment: "" }, { "Transit Time": "Days" }, { Rate: "$" }]
  ]
};

const QUOTE_INFORMATION_SPANISH = {
  header: {
    textContent: "Información de la cotización"
  },
  rows: [
    [
      { Modo: "" },
      { Equipo: "" },
      { "Tiempo de tránsito": "Days" },
      { Tarifa: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_PARTIAL = {
  header: {
    textContent: "Quote Information"
  },
  rows: [
    [
      { Mode: "Partial Load - Non-Hazmat" },
      { Equipment: "" },
      { "Transit Time": "Days" },
      { Rate: "$" }
    ],
    [
      { Mode: "FTL" },
      { Equipment: "" },
      { "Transit Time": "Days" },
      { Rate: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_PARTIAL_SPANISH = {
  header: {
    textContent: "Información de la cotización"
  },
  rows: [
    [
      { Modo: "Partial Load - Non-Hazmat" },
      { Equipo: "" },
      { "Tiempo de tránsito": "Days" },
      { Tarifa: "$" }
    ],
    [
      { Modo: "FTL" },
      { Equipo: "" },
      { "Tiempo de tránsito": "Days" },
      { Tarifa: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_TEMPCONTROL = {
  header: {
    textContent: "Quote Information"
  },
  rows: [
    [
      { Mode: "Reefer Full Truck Load" },
      { Equipment: "Reefer Van" },
      { "Transit Time": "Days" },
      { Rate: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_TEMPCONTROL_SPANISH = {
  header: {
    textContent: "Información de la cotización"
  },
  rows: [
    [
      { Modo: "FTL – Non-Hazmat" },
      { Equipo: "Reefer Van" },
      { "Tiempo de tránsito": "Days" },
      { Tarifa: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_TEMPCONTROL_REEFER_FFE_KOOLPAK = {
  header: {
    textContent: "Quote Information"
  },
  rows: [
    [
      { Mode: "Reefer Less than Truckload" },
      { ETT: "Picks ____ / Delivers ____  the following week" },
      {
        "Temperature Range offered by our carrier":
          "Frozen: Set point -10°F providing an air temperature range of -10° to 31°F / Cooler: Set point 33°F providing an air temperature range of 33° to 38°F"
      },
      { Rate: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_TEMPCONTROL_REEFER_ROADTEX = {
  header: {
    textContent: "Quote Information"
  },
  rows: [
    [
      { Mode: "Reefer Less than Truckload" },
      { ETT: "___ to ___ days, not including pick up day or weekends." },
      { "Temperature Range offered by our carrier": "" },
      { Rate: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_TEMPCONTROL_REEFER_CANNON = {
  header: {
    textContent: "Quote Information"
  },
  rows: [
    [
      { Mode: "Reefer Less than Truckload" },
      { ETT: "Same or next day" },
      { "Temperature Range offered by our carrier": "" },
      { Rate: "$" }
    ]
  ]
};

const QUOTE_INFORMATION_TEMPCONTROL_REEFER_SPANISH = {
  header: {
    textContent: "Información de la cotización"
  },
  rows: [
    [
      { Modo: "Reefer Less than Truckload" },
      { "Tiempo de tránsito estimado": "" },
      { "Rango de temperatura manejada por el transportista": "" },
      { Tarifa: "$" }
    ]
  ]
};

module.exports = {
  FREIGHT_DETAILS,
  FREIGHT_DETAILS_SPANISH,
  FREIGHT_DETAILS_TEMPCONTROL,
  FREIGHT_DETAILS_TEMPCONTROL_SPANISH,
  QUOTE_INFORMATION,
  QUOTE_INFORMATION_SPANISH,
  QUOTE_INFORMATION_PARTIAL,
  QUOTE_INFORMATION_PARTIAL_SPANISH,
  QUOTE_INFORMATION_TEMPCONTROL,
  QUOTE_INFORMATION_TEMPCONTROL_SPANISH,
  QUOTE_INFORMATION_TEMPCONTROL_REEFER_FFE_KOOLPAK,
  QUOTE_INFORMATION_TEMPCONTROL_REEFER_ROADTEX,
  QUOTE_INFORMATION_TEMPCONTROL_REEFER_CANNON,
  QUOTE_INFORMATION_TEMPCONTROL_REEFER_SPANISH
};
